<script setup lang="ts">
import Head from './components/Head.vue'
import Foot from './components/Foot.vue'
import { onMounted, ref, watch } from 'vue';
import {useStore} from 'vuex'
import Bus  from './uitls/Bus'
//窗口大小 
const screenWidth = ref(window.innerWidth )
let store = useStore()
let scrollTop = ref()
let notFound = ref<boolean>(false)
onMounted(() => {
    window.onresize = () => {
        screenWidth.value = window.innerWidth
    }
    window.addEventListener('scroll', function () {
         scrollTop.value = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    })
  
})
watch(() => screenWidth, (oldVal,newVal) => {
    if (oldVal.value < 768) {
        store.commit('changeState',true) 
    } else {
        store.commit('changeState',false) 
    }
},
    { 
        deep:true,
        immediate: true
    });
    const goTop = ()=>{
      window.scrollTo({ top: 0, behavior: 'smooth' }); // 平滑滚动到顶部
    }
   
</script>
<template>
    <Head v-if="!notFound" />
    <router-view />
    <Foot v-if="!notFound"  />
    <!-- 返回顶部 -->
    <div class="goTop" @click="goTop" :class="scrollTop>600?'show':''">
      <i class="iconfont icon-shangchuan"></i>
      <div>
        返
        <br/>回
        <br/>顶
        <br/>部
      </div>
    </div>
</template>

<style >
@import url('//at.alicdn.com/t/c/font_4406895_vhl0dpz69h.css');
.goTop{
  position: fixed;
  right: 20px;
  top: 75%;
  cursor: pointer;
  display: none;
  color: #409eff;
}
.goTop:hover{
  color: red;
}
::-webkit-scrollbar {
  width: 0 !important;
}
.show{
  display: block;
}
* {
  padding: 0;
  margin: 0;
  list-style: none;
  box-sizing: border-box;
  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
}

a {
  text-decoration: none;
  color: #fff;
}

a:hover {
  color: #409eff;
}
</style>
